import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Slide } from "@mui/material";

export const OcPageTransition: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation() || "/";
  const [showFade, setShowFade] = useState(false);

  useEffect(() => {
    setShowFade(true);
    return () => {
      setShowFade(false);
    };
  }, [location]);

  return (
    <Slide id="oc-page-transition-profile-menu" in={showFade} direction="left">
      <Box>{children}</Box>
    </Slide>
  );
};

export default OcPageTransition;
